<template>
  <div class="colorsItem" :style="{ backgroundColor: bgColor }">
    <div>
      <img :src="'./img/' + img" :alt="`Skojarzenie dla cyfry ${itemNumber}`" />
    </div>
    <div :style="{ color: textColor }" class="description">
      <span style="opacity: 0.4">{{ itemNumber }}</span
      ><br />
      <!-- {{ itemDescription }} -->
      <span v-html="itemDescription"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemNumber', 'img', 'bgColor', 'textColor', 'itemDescription'],
};
</script>

<style scoped>
.colorsItem {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  padding: 12px 16px;
}
.colorsItem img {
  width: clamp(110px, 30vw, 220px);
  aspect-ratio: 1;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
}
.description {
  flex: 0 1 250px;
  padding: 10px 0;
  font-size: 0.8rem;
  line-height: 1.3rem;
}

@media (max-width: 420px) {
  .colorsItem {
    gap: 12px;
    padding: 10px;
  }
}
</style>
